module.exports = __webpack_public_path__ + "h5/img/production-icon.60f8d507.png";